import { NextPageWithLayout } from '@/app/types'
import { IndexRootPage } from '@/components/pages/index'
import { LayoutDefault } from '@/layouts/default'

const IndexPage: NextPageWithLayout = () => {
  return <IndexRootPage></IndexRootPage>
}

IndexPage.getLayout = page => {
  return <LayoutDefault noBottomOffset>{page}</LayoutDefault>
}

export default IndexPage
